export class UserSecuritySerializedModel {
	constructor(
		public UserId: number,
		public SecurityRolesKey: number) {

	}
}